import { NextPage } from 'next';
import { GetServerSideProps } from 'next';
import ReaderDetail from '@/components/screens/reader-detail/ReaderDetail';
import { API_URL, BOOKS_FOR_PAGE } from '@/helpers/variables';
import { IReaderDetail } from '@/interfaces/readerDetail.interface';

interface IReaderDetailPageDynamicProps {
  reader: IReaderDetail;
}

const ReaderDetailPageDynamic: NextPage<IReaderDetailPageDynamicProps> = ({ reader }) => {
  return <ReaderDetail reader={reader} />;
};
export const getServerSideProps: GetServerSideProps = async (context) => {
  const { alias } = context.query;

  const [readerRes] = await Promise.all([fetch(`${API_URL}satellite/person/${alias}?page=1&page_size=${BOOKS_FOR_PAGE}`)]);
  const [reader] = await Promise.all([readerRes.json()]);

  // // Check Fetched Data Error
  if (!reader.person_books_count) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      reader,
    },
  };
};

export default ReaderDetailPageDynamic;
